//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PDPCommentControls',
  props: {
    fragmentForLink: {
      type: [String, Number],
      default: null,
    },
    discussionDisplayPath: {
      type: String,
      required: true,
    },
    approved: {
      type: Boolean,
    },
    resolved: {
      type: Boolean,
    },
    pinned: {
      type: Boolean,
    },
    blacklist: {
      type: Boolean,
    },
    whitelist: {
      type: Boolean,
    },
    commentTypeTitle: {
      type: String,
      required: true,
    },
    filterComments: {
      type: Boolean,
    },
    isPinned: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    forReviews: {
      type: Boolean,
      required: true,
    },
    showLink: {
      type: Boolean,
      default: true,
    },
  },
  inject: {
    deal: {},
    forDiscussionPage: {
      default: false,
    },
  },
  computed: {
    commentLinkTarget() {
      if (this.forDiscussionPage) {
        return null;
      }
      return '_blank';
    },
    commentLinkUrl() {
      // jw: the fragmentForLink is used to anchor the link to a element on the page. This is not
      //     always present. Discussions linked on the discussion page for example.
      if (this.fragmentForLink) {
        return `${this.discussionDisplayPath}#${this.fragmentForLink}`;
      }
      return this.discussionDisplayPath;
    },
    linkLabel() {
      if (!this.isPinned) {
        return 'Link';
      }

      return `Original ${this.commentTypeTitle}`;
    },
    showControls() {
      return this.user.isAuthenticated && this.user.isModerator;
    },
  },
  methods: {
    getLabel(value, labelTrue, labelFalse) {
      return (value) ? labelTrue : labelFalse;
    },
    updateAction(type, value) {
      this.$emit('update-action', { type, value });
    },
  },
};
